import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import TableC from '../../../basicElement/TableC';
import ExportUtil from '../../../../common/ExportUtil';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';

class CoOperationLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = record => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { coTraceId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.getCoLogList,
            data: { coTraceLogId: coTraceId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.logList,
                    loading: false,
                });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => ([
        {
            title: '更新时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 150,
        }, {
            title: '更新人',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 120,
            render: (text, record) => `${text}[${record.employeeCode}]`,
        }, {
            title: '更新字段',
            dataIndex: 'field',
            key: 'field',
            width: 120,
        }, {
            title: '更新前',
            dataIndex: 'oldContent',
            key: 'oldContent',
        }, {
            title: '更新后',
            dataIndex: 'newContent',
            key: 'newContent',
        },
    ])

    render() {
        const { visible, loading, data } = this.state;
        return (
            <Modal
                title="更新日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width={1000}
                bodyStyle={{ maxHeight: 700 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{ margin: 20 }}>
                    <div>
                        <TableC
                            data={data}
                            scrollY={400}
                            loading={loading}
                            columns={this.getColumns()}
                            rowKey="contractRemittanceLogId"
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}
class FundsOperationLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    show = record => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { investigationId }, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryRemittanceTraceLogList,
            data: {
                investigationId,
                offset: current,
                limit: pageSize,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    loading: false,
                    pagination,
                });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => ([
        {
            title: '更新时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 150,
        }, {
            title: '更新人',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 120,
        }, {
            title: '更新字段',
            dataIndex: 'changeContent',
            key: 'changeContent',
            width: 120,
        }, {
            title: '更新前',
            dataIndex: 'beforeChange',
            key: 'beforeChange',
            width: 120,
        }, {
            title: '更新后',
            dataIndex: 'afterChange',
            key: 'afterChange',
        },
    ])

    handleTableChange = params => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { visible, loading, data, pagination } = this.state;
        return (
            <Modal
                title="更新日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width={900}
                bodyStyle={{ maxHeight: 700 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{ margin: 20 }}>
                    <div>
                        <TableC
                            data={data}
                            scrollY={450}
                            loading={loading}
                            pagination={pagination}
                            columns={this.getColumns()}
                            rowKey="remittanceTraceLogId"
                            onChange={this.handleTableChange}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

class PreviewModal extends Component {
    state = {
        visible: false,
        daily: [],
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        loading: false,
    };

    loadData = (id, investigationJdeContractCode) => {
        this.setState({
            loading: true,
        });
        const { type, pagination } = this.state;
        const { current, pageSize } = pagination;
        const options = {
            url: API_URL.investigation.queryRemittanceAplicationInfo,
            data: {
                investigationId: id,
                type,
                offset: current,
                limit: pageSize - 1,
                investigationJdeContractCode,
            },
            dataType: 'json',
            doneResult: (data => {
                const { remittanceAmountTotal, jdeContractAmountTotal, totalCount } = data || {};
                pagination.total = totalCount + Math.ceil(totalCount / (pageSize - 1));
                this.setState({
                    loading: false,
                    daily: data.datas,
                    remittanceAmountTotal,
                    jdeContractAmountTotal,
                    pagination,
                });
            }),
            errorResule: (data => {
                this.setState({
                    loading: false,
                });
            }),
        };
        $.sendRequest(options);
    };

    show = (record, type) => {
        this.setState({
            visible: true,
            record,
            type,
        }, () => {
            record.investigationJdeContractCode ?
            this.loadData(record.investigationId, record.investigationJdeContractCode) :
            this.loadData(record.investigationId);
        });
    };

    hide = () => {
        this.setState({
            visible: false,
            daily: [],
            pagination: {
                pageSize: 10,
                current: 1,
            },
        });
    };

// 请款规则-查看详情 / 当前可请款节点-查看详情
    getColumns = () => [
        {
            title: '请款单号',
            dataIndex: 'remittanceCode',
            key: 'remittanceCode',
            width: 100,
            fixed: 'left',
            render: text => text == '合计' ? <b>{text}</b> : text,
        }, {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 120,
        }, {
            title: '合同主键',
            dataIndex: 'investigationJdeContractId',
            key: 'investigationJdeContractId',
            width: 120,
        }, {
            title: '合同额含税/人民币(元)',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            width: 120,
            render: (text, record) => record.remittanceCode == '合计' ? <b>{format('money', text)}</b> : format('money', text),
        }, {
            title: '客户付款单位',
            dataIndex: 'customerCompany',
            key: 'customerCompany',
            width: 120,
        }, {
            title: '客户CSA',
            dataIndex: 'csaNameCode',
            key: 'csaNameCode',
            width: 120,
        }, {
            title: '请款笔数',
            dataIndex: 'remittanceNum',
            key: 'remittanceNum',
            width: 120,
        }, {
            title: '请款节点',
            dataIndex: 'cashReqNode',
            key: 'cashReqNode',
            width: 120,
        }, {
            title: '合同约定请款金额/人民币（元）',
            dataIndex: 'remittanceAmount',
            key: 'remittanceAmount',
            width: 120,
            render: (text, record) => record.remittanceCode == '合计' ? <b>{format('money', text)}</b> : format('money', text),
        }, {
            title: 'milestone到达日期',
            dataIndex: 'cashReqNodeDateShow',
            key: 'cashReqNodeDateShow',
            width: 120,
        }, {
            title: '确认可请款日期',
            dataIndex: 'baConfirmCashReqDate',
            key: 'baConfirmCashReqDate',
            width: 120,
        }, {
            title: '请款进度',
            dataIndex: 'paymentProgress',
            key: 'paymentProgress',
            width: 120,
        }]

    // BA填写更新请款进度-查看详情
    getColumns1 = () => [
        {
            title: '请款单号',
            dataIndex: 'remittanceCode',
            key: 'remittanceCode',
            width: 100,
            fixed: 'left',
            render: text => text == '合计' ? <b>{text}</b> : text,
        }, {
            title: '客户付款单位',
            dataIndex: 'customerCompany',
            key: 'customerCompany',
            width: 120,
        }, {
            title: '客户CSA',
            dataIndex: 'csaNameCode',
            key: 'csaNameCode',
            width: 120,
        }, {
            title: '请款笔数',
            dataIndex: 'remittanceNum',
            key: 'remittanceNum',
            width: 120,
        }, {
            title: '请款节点',
            dataIndex: 'cashReqNode',
            key: 'cashReqNode',
            width: 120,
        }, {
            title: '合同约定请款金额/人民币（元）',
            dataIndex: 'remittanceAmount',
            key: 'remittanceAmount',
            width: 120,
            render: (text, record) => record.remittanceCode == '合计' ? <b>{format('money', text)}</b> : format('money', text),
        }, {
            title: 'milestone到达日期',
            dataIndex: 'cashReqNodeDateShow',
            key: 'cashReqNodeDateShow',
            width: 120,
        }, {
            title: '确认可请款日期',
            dataIndex: 'baConfirmCashReqDate',
            key: 'baConfirmCashReqDate',
            width: 120,
        }, {
            title: '请款进度',
            dataIndex: 'paymentProgress',
            key: 'paymentProgress',
            width: 120,
        }, {
            title: '请款进度具体描述',
            dataIndex: 'paymentProgressComment',
            key: 'paymentProgressComment',
            width: 120,
        }]

    getDataSource = () => {
        const dailys = [];
        const { daily, pagination, remittanceAmountTotal, jdeContractAmountTotal } = this.state;
        const total = 0;
        daily.map((d, i) => {
            dailys.push({
                index: ((pagination.current - 1) || 0) * 10 + i + 1,
                ...d,
            });
        });
        dailys.push({
            remittanceCode: '合计',
            remittanceAmount: remittanceAmountTotal,
            jdeContractAmount: jdeContractAmountTotal,
        });
        return dailys;
    }

    splitParams = params => {
        const result = {};
        for (const [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }
    export = () => {
        const {
            record,
            type,
         } = this.state;
        const { investigationId, investigationJdeContractCode } = record || {};
        // const params = this.splitParams(searchParams);
        const url = API_URL.investigation.exportRemittanceAplicationInfo;
        investigationJdeContractCode ? ExportUtil.export({ investigationId, type, investigationJdeContractCode }, null, url) :
        ExportUtil.export({ investigationId, type }, null, url);
    }

    handleTableChange = params => {
        const { record } = this.state;
        const { investigationId } = record || {};
        this.setState({
            ...params,
        }, () => {
            this.loadData(investigationId);
        });
    }

    render() {
        const {
            visible, loading, pagination,
            record, type,
        } = this.state;
        const { modalTitle } = record || {};
        return (
            <Modal
                title={modalTitle}
                visible={visible}
                onCancel={this.hide}
                className="preview-modal_log"
                // wrapClassName="vertical-center-modal"
                width="1000px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div className="content">
                    <div style={{ marginBottom: 10, textAlign: 'right' }}>
                        <Button key="export" type="primary" onClick={this.export}>导出</Button>
                    </div>
                    <TableC
                        data={this.getDataSource()}
                        scrollY={350}
                        loading={loading}
                        columns={(type == 'rule' || type == 'node') ? this.getColumns() : this.getColumns1()}
                        rowKey="remittanceCode"
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                </div>
            </Modal>
        );
    }
}

class CoApprovalOperationLog extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = record => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { coTraceId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryApprovalCoTraceLog,
            data: { coTraceId },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.coTraceApprovalLogs,
                    loading: false,
                });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => ([
        {
            title: '操作时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 150,
        }, {
            title: '操作人',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 120,
            render: (text, record) => `${text}(${record.employeeCode})`,
        }, {
            title: '操作内容',
            dataIndex: 'workNameShow',
            key: 'workNameShow',
            width: 140,
        }, {
            title: '操作结果',
            dataIndex: 'result',
            key: 'result',
            width: 120,
            render: text => text == 'WAITE' ? '待审批' : (text == 'REJECT' ? '审批不通过' : (text == 'AGREE' ? '审批通过' : '')),
        }, {
            title: '拒绝/不通过原因',
            dataIndex: 'reason',
            key: 'reason',
        },
    ])

    render() {
        const { visible, loading, data } = this.state;
        return (
            <Modal
                title="操作日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width={900}
                bodyStyle={{ maxHeight: 700 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{ margin: 20 }}>
                    <div>
                        <TableC
                            data={data}
                            scrollY={450}
                            loading={loading}
                            columns={this.getColumns()}
                            rowKey="contractRemittanceLogId"
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export { CoOperationLog, FundsOperationLog, PreviewModal, CoApprovalOperationLog };



// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/OperationLog.js